<div class="kng-shell">
  <kng-header-nav
    (clickEventTop)="emitPath($event)"
    (clickEventLocationTop)="emitLocation($event)"
    (customerSessionEvent)="endCustomerSession()"
    class="kng-shell__header"
    #header
    [state]="state.header" 
    [customerState]="customerState"
    (selectedLang)="emitSelectedLang($event)"
    [changeLangaugeButton]="state.changeLanguageButton"
  ></kng-header-nav>
  <ng-content select="[banner-slot]"></ng-content>
  <kng-banner
    class="kng-shell__banner" *ngIf="state.banner.open && !state.banner.alertBanner"
    #banner
    id="bannerNotAlert"
    [state]="state.banner"
    (bannerClickEvent)="bannerClickHandler($event)"
  ></kng-banner>
  <kng-content
    class="kng-shell__content"
    id="mainContent"
    #content
    [state]="state.content"
    [ngClass]="{ 'kng-shell__content--windowed': state.content.windowed }"
  >
    <ng-content select="[role=content]"></ng-content>
  </kng-content>
  <kng-footer
    class="kng-shell__footer"
    (languageSelectionChanged)="notifyAboutLanguageSelection($event)"
    #footer
    [state]="state.footer">
    <ng-content select="[role=footer]"></ng-content>
  </kng-footer>
</div>
